import { Classes, Styles } from "jss";
import { createUseStyles } from "react-jss";
import { ThemeItem } from "../../../../theme";
import { SideLinksProps } from ".";

export type SideLinksClassNames =
  | "linksList"
  | "linksItem"
  | "listItemCopyRight"
  | "item";

export type SideLinksClasses = Classes<SideLinksClassNames>;
export type SideLinksStyles = Styles<SideLinksClassNames>;
export type SideLinksStylesProps = SideLinksProps;

const getStyles: (theme: ThemeItem) => SideLinksStyles = (
  theme: ThemeItem
) => ({
  "@media (max-width: 992px)": {
    linksList: {
      flexDirection: "column",
      alignItems: "center",
    },
    item: { margin: "8px 0" },
  },
  linksList: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 20,
  },
  linksItem: {
    fontWeight: 200,
    color: "#0000004d",
    "&:first-child": {
      color: "#0000004d",
    },
    "&:hover": {
      color: "#000000",
    },
  },
  item: {},
  listItemCopyRight: {
    color: "#0000004d",
  },
});

const useSideLinksStyles: (
  data?: SideLinksStylesProps
) => SideLinksClasses = createUseStyles<ThemeItem, SideLinksClassNames>(
  getStyles
);

export default useSideLinksStyles;
